import { FC, useState, ChangeEvent } from 'react';
import { useStyles } from './styles';
import { Grid, Paper, Tabs, Tab } from '@material-ui/core';
import TabPanel from 'components/TabPanel';
import { EmailTemplatesTable } from 'components/Tables';
import {
  SmtpSettingsForm,
  EndUserSettingsForm,
  EndUserConfigForm,
  // EndUserAttributeForm,
  EndUserAddressForm,
} from 'components/Forms';
// import EndUserKeyMangement from 'components/Forms/EndUserKeyMangement';
import { CustomAttributeTable } from 'components/Tables/CustomAttributeTable/CustomAttributeTable';
import { AccessManagementTable } from 'components/Tables/AccessManagementTable/AccessMangementTable';
// import { OdicTable } from 'components/Tables/OdicTable';
// import { useStore } from 'hooks/useRootStore';
// import SamlTable from 'components/Tables/SAMLTable/SamlTable';
// import { useStore } from 'hooks/useRootStore';
import EndUserSamlTable from 'components/Tables/SAMLTable/EndUserSamlTable';
function a11yProps(index: string) {
  return {
    id: `wrapped-tab-${index}`,
    'aria-controls': `wrapped-tabpanel-${index}`,
  };
}

export const SettingsTabs: FC = () => {
  const classes = useStyles();
  const [value, setValue] = useState<string>('one');
  const handleChange = (event: ChangeEvent<unknown>, newValue: string) => {
    setValue(newValue);
  };
  // const {
  //   userStore: { user },
  // } = useStore();
  const profile = JSON.parse(localStorage.getItem('Profile') as string);
  const permission = profile?.permission;
  return (
    <Grid item xl className={classes.tabsPanel}>
      <Paper className={classes.tabsPaper}>
        <div className={classes.tabsContainer}>
          {permission !== 'EndUser' && permission !== 'Manager' && (
            <Tabs
              value={value}
              className={classes.tabs}
              TabIndicatorProps={{ style: { color: 'transparent', background: 'transparent' } }}
              onChange={handleChange}
              variant='scrollable'
              scrollButtons='auto'
            >
              <Tab value='one' wrapped label='Email Templates' {...a11yProps('one')} className={classes.label} />
              <Tab value='two' wrapped label='SMTP' {...a11yProps('two')} className={classes.label} />
              <Tab value='tree' wrapped label='Portal' {...a11yProps('tree')} className={classes.label} />
              <Tab value='four' wrapped label='Policy' {...a11yProps('four')} className={classes.label} />
              <Tab value='five' wrapped label='Access Management' {...a11yProps('five')} className={classes.label} />
              {/* <Tab value='six' wrapped label='Attributes' {...a11yProps('six')} className={classes.label} /> */}
              <Tab value='six' wrapped label='Networking' {...a11yProps('six')} className={classes.label} />
              <Tab value='seven' wrapped label='Custom Attributes' {...a11yProps('seven')} className={classes.label} />
              {/* <Tab value='eight' wrapped label='OIDC' {...a11yProps('eight')} className={classes.label} />
            <Tab value='nine' wrapped label='SAML IdP' {...a11yProps('nine')} className={classes.label} /> */}
            </Tabs>
          )}
        </div>
        {permission !== 'EndUser' && permission !== 'Manager' ? (
          <div>
            <TabPanel value={value} index='one'>
              <EmailTemplatesTable />
            </TabPanel>
            <TabPanel value={value} index='two'>
              <SmtpSettingsForm />
            </TabPanel>
            <TabPanel value={value} index='tree'>
              <EndUserConfigForm type='general' />
            </TabPanel>
            <TabPanel value={value} index='four'>
              <EndUserSettingsForm
                type='policy'
                description='Activate this username policy for all new user accounts provisioned'
              />
            </TabPanel>
            <TabPanel value={value} index='five'>
              <AccessManagementTable />
            </TabPanel>
            {/* <TabPanel value={value} index='six'>
            <EndUserAttributeForm type='general'></EndUserAttributeForm>
          </TabPanel> */}
            <TabPanel value={value} index='six'>
              <EndUserAddressForm></EndUserAddressForm>
            </TabPanel>
            <TabPanel value={value} index='seven'>
              <CustomAttributeTable></CustomAttributeTable>
            </TabPanel>
            {/* <TabPanel value={value} index='eight'>
            <OdicTable />
          </TabPanel>
          <TabPanel value={value} index='nine'>
            <SamlTable />
          </TabPanel> */}
          </div>
        ) : (
          <div>
            <TabPanel value={value} index='one'>
              <EndUserSamlTable />
            </TabPanel>
          </div>
        )}
      </Paper>
    </Grid>
  );
};
